import React from "react";

const FormDots = ({ form }) => {
  const chars = (form || "").split("").slice(0, 5);
  if (!chars.length) return null;
  return (
    <div className="pbd-form-dots" aria-label={form ? `Form: ${form}` : undefined}>
      {chars.map((c, i) => (
        <span key={`${c}-${i}`} className={`pbd-form-dot pbd-form-${c.toLowerCase()}`}>
          {c}
        </span>
      ))}
    </div>
  );
};

const StandingSide = ({ side, team }) => {
  if (!side) {
    return (
      <div className="pbd-insight-standing">
        <span className="pbd-insight-team truncate">{team?.name || "—"}</span>
        <span className="pbd-insight-na">No table data</span>
      </div>
    );
  }

  return (
    <div className="pbd-insight-standing">
      <span className="pbd-insight-team truncate" title={team?.name}>
        {team?.name || "—"}
      </span>
      <div className="pbd-insight-stats">
        <span>
          <em>Rank</em>
          <strong>{side.rank != null ? `#${side.rank}` : "—"}</strong>
        </span>
        <span>
          <em>Pts</em>
          <strong className="tabular-nums">{side.points ?? "—"}</strong>
        </span>
        <FormDots form={side.form} />
      </div>
    </div>
  );
};

/** Standings + prediction counts — always visible on the fixture card (mobile BetFixture parity). */
const FixtureCardInsight = ({ fixture }) => {
  const preds = fixture?.predictionCounts;
  const community = preds?.communityPredictions ?? 0;
  const ai = preds?.aiPredictions ?? 0;
  const total = preds?.totalPredictions ?? 0;
  const hasPreds = Boolean(preds);
  const standings = fixture?.standings;
  const hasStandings = Boolean(standings?.home || standings?.away);

  if (!hasPreds && !hasStandings) return null;

  return (
    <div className="pbd-fixture-insight">
      {hasPreds ? (
        <div className="pbd-insight-block">
          <p className="pbd-insight-label">Predictions</p>
          <div className="pbd-insight-preds">
            <div className="pbd-insight-pred">
              <span>Community</span>
              <strong className="tabular-nums">{community}</strong>
            </div>
            <div className="pbd-insight-pred pbd-insight-pred-ai">
              <span>AI</span>
              <strong className="tabular-nums">{ai}</strong>
            </div>
            <div className="pbd-insight-pred">
              <span>Total</span>
              <strong className="tabular-nums">{total}</strong>
            </div>
          </div>
        </div>
      ) : null}

      {hasStandings ? (
        <div className="pbd-insight-block">
          <p className="pbd-insight-label">League standing</p>
          <div className="pbd-insight-standings">
            <StandingSide side={standings.home} team={fixture?.teams?.home} />
            <StandingSide side={standings.away} team={fixture?.teams?.away} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FixtureCardInsight;
